var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7508 15.9532C18.973 16.7573 16.9924 17.0006 15.0729 16.6507C13.1533 16.3008 11.386 15.3743 10.0063 13.9946C8.62655 12.6149 7.70002 10.8475 7.35011 8.92796C7.00019 7.0084 7.24351 5.02779 8.04764 3.25C6.63231 3.88961 5.39328 4.86303 4.43684 6.08675C3.4804 7.31047 2.83511 8.74795 2.55633 10.2759C2.27754 11.8038 2.37359 13.3765 2.83623 14.8592C3.29886 16.3418 4.11428 17.6901 5.21252 18.7883C6.31076 19.8866 7.65903 20.702 9.14167 21.1646C10.6243 21.6272 12.1971 21.7233 13.725 21.4445C15.2529 21.1657 16.6904 20.5204 17.9141 19.564C19.1378 18.6076 20.1112 17.3685 20.7508 15.9532Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.dda092446cb41f56807d0e0d92ea0f91.svg";
export { ForwardRef as ReactComponent };